import {DepartmentList} from "./DepartmentList";
import {DepartmentEdit} from "./DepartmentEdit";
import {DepartmentCreate} from "./DepartmentCreate";

export default {
    list: DepartmentList,
    create: DepartmentCreate,
    edit: DepartmentEdit
};
